import React from 'react';
import styled from 'styled-components';
import StyledPopover from '../Popover';
import { KPMGNotificationsButtonIcon } from '../../../assets/icons';
import Table from '../table/Table';
import notificationsTableConfig from '../../../configs/table/configs/notifications';
import { columns } from '../../../configs/table/columns/notifications';
import Badge from '../Badge';
import Color from '../../../enums/color';
import { usePartialState } from '../../../hooks/usePartialState';
import store from '../../../store';
const Container = styled.div `
  display: flex;
  cursor: pointer;
`;
const Content = styled.div `
  width: 60vw;
  padding-top: 12px;
`;
const Notifications = () => {
    const { currentUser: { unreadNotifications } } = usePartialState(store.auth, ['currentUser.unreadNotifications']);
    return (<StyledPopover destroyPopoverOnHide getContent={() => (<Content>
          <Table columns={columns} tableConfig={notificationsTableConfig}/>
        </Content>)} trigger='click' arrowPointAtCenter placement='bottomRight'>
      <Container>
        <Badge count={unreadNotifications} background={Color.Red}>
          <KPMGNotificationsButtonIcon />
        </Badge>
      </Container>
    </StyledPopover>);
};
export default Notifications;
